import mx from '../mx';

export const mxPoint = mx.mxPoint;
